module.exports = __webpack_public_path__ + "static/media/f38dcade-0c3d-4af7-8028-0d4130c21bd8.303b4304.JPG";